import React from 'react';

const MyLogo = props => <img height="40" alt="Logo" {...props} src={`${process.env.PUBLIC_URL}/favicon.png`} />;

export default MyLogo;
